import { useEffect } from "react";
import { ZoomMtg } from "@zoomus/websdk";

function ZoomInterface(props) {
  useEffect(() => {
    let meetingEmail = "";
    let meetingName = "";

    if (props.user != null) {
      meetingEmail = props.user.email;
      meetingName = props.user.nome + " " + props.user.cognome;
    } else {
      meetingEmail = props.hostEmail;
      meetingName = "Servizi Locali";
    }

    if (props.signature) {
      ZoomMtg.init({
        leaveUrl:
          props.clientName +
          "?meetingNumber=" +
          props.meetingData.meetingNumber,
        disableRecord: false,
        success: (success) => {
          console.log(success);
          ZoomMtg.join({
            apiKey: props.meetingData.apiKey,
            signature: props.signature,
            meetingNumber: props.meetingData.meetingNumber,
            // passWord: props.meetingData.pwd,
            passWord: "",
            userName: meetingName,
            userEmail: meetingEmail,
            tk: "",
            success: function (res) {
              console.log(res);

              // setIsJoined(true);

              ZoomMtg.record({
                record: true,
              });

              ZoomMtg.showRecordFunction({
                show: true,
              });
            },
            error: function (res) {
              console.log(res);
            },
          });
        },
        error: (error) => {
          console.log(error);
        },
      });
    }
  }, []);

  return <></>;
}

export default ZoomInterface;
